import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useSERPState } from '~/core/state/SERPStateContext';
import SanitizedHTML from '~/utils/components/SanitizedHTML';
import { getResultContent } from '~/utils/getResultContent';
import getResultTitle from '~/utils/getResultTitle';
import { useProductContext } from './productResultContext';

export type ProductResultHeadProps = {
    children?: React.ReactNode;
};

const ProductResultHead = ({ children }: ProductResultHeadProps) => {
    const { result, style, linkElementRef } = useProductContext();
    const state = useSERPState();

    return (
        <div
            className={classNames(style.serpProductInfo, {
                [style.inRows]: state.resultLayout === 'rows',
            })}
        >
            {children}

            <div>
                {undefined !== result.brand ? (
                    <span
                        role="paragraph"
                        className={style.serpProductBrand}
                        key="brand"
                        data-testid="product-result-brand"
                    >
                        {result.brand}
                    </span>
                ) : null}
                <div
                    role="heading"
                    aria-level={3}
                    className={style.serpProductTitle}
                    data-testid="product-result-heading"
                >
                    {undefined !== result.url ? (
                        <div role="link" tabIndex={0} ref={linkElementRef}>
                            <SanitizedHTML html={getResultTitle(result)} key="heading" />
                        </div>
                    ) : null}
                </div>
                <div role="paragraph" className={style.serpProductDescription} data-testid="product-result-description">
                    <SanitizedHTML html={getResultContent(result)} key="description" />
                </div>
                {undefined !== result.productCode ? (
                    <div role="paragraph" className={style.serpProductNumber} data-testid="product-result-code">
                        <FormattedMessage id="product_code" defaultMessage="Kód:" /> {result.productCode}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ProductResultHead;
